import { action, computed, makeObservable, observable } from 'mobx';

import { TAvatarBackgroundColorIndex } from 'APP/components/Avatar/Avatar';
import {
  IPersonalizedWorkspace,
  IWorkspace,
  WorkspaceRole,
  IWorkspaceSetting,
} from 'APP/model/workspace/workspaceModel.types';

export class Workspace {
  @observable name = '';
  @observable description = '';
  @observable avatarUrl: string | null = null;
  @observable site = '';
  @observable membersCount = 0;
  @observable role: WorkspaceRole = WorkspaceRole.MEMBER;
  @observable workspaceSetting: IWorkspaceSetting | Record<string, never> = {};
  @observable region: string | null = null;

  constructor() {
    makeObservable(this);
  }

  @action
  public updatePersonalizedWorkspace(data: IPersonalizedWorkspace): void {
    this.updateWorkspace(data.workspace);
    this.role = data.role;
    this.workspaceSetting = data.workspaceSetting || {};
    this.region = data?.region || null;
  }

  @action
  public updateWorkspace(data: IWorkspace): void {
    this.name = data.name;
    this.description = data.description || '';
    this.avatarUrl = data.avatarUrl || null;
    this.membersCount = data.usersCount;
  }

  @action
  public setRole(role: WorkspaceRole): void {
    this.role = role;
  }

  @action
  public updatedMembersCount(count: number): void {
    this.membersCount = count;
  }

  @computed
  public get avatarColorIndex(): TAvatarBackgroundColorIndex {
    let hash = 0;
    for (let i = 0; i < this.name.length; i++) {
      hash += this.name.charCodeAt(i);
    }
    return (hash % 10).toString() as TAvatarBackgroundColorIndex;
  }
}
